<app-main-nav></app-main-nav>
<section>
<router-outlet></router-outlet>
</section>
<app-footer></app-footer>